import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import { VpIcon } from '@vp-ui';
import VpConditionalUpgradeWrapper from '@vp-ui/components/VpConditionalUpgradeWrapper/VpConditionalUpgradeWrapper';

const VpInfoMenuItem = ({
  item,
  onSelect,
  optionalLabelValue = 'label',
  disabled,
  conditionalProps,
  ...rest
}) => {
  const onItemSelect = (e) => {
    onSelect && onSelect(e, item);
  };

  const styles =
    item?.variant === 'error'
      ? {
          color: 'vpColors.redMain'
        }
      : {};

  const MENU_ITEM = (
    <>
      {item?.icon && (
        <ListItemIcon>
          <VpIcon sx={styles} icon={item?.icon} />
        </ListItemIcon>
      )}
      <ListItemText primaryTypographyProps={{ sx: styles }}>
        {item[optionalLabelValue]}
      </ListItemText>
    </>
  );

  if (conditionalProps) {
    return (
      <VpConditionalUpgradeWrapper {...conditionalProps}>
        {({ isDisabled }) => (
          <MenuItem key={item.id} onClick={onItemSelect} disabled={isDisabled} {...rest}>
            {MENU_ITEM}
          </MenuItem>
        )}
      </VpConditionalUpgradeWrapper>
    );
  }

  return (
    <MenuItem key={item.id} onClick={onItemSelect} disabled={disabled} {...rest}>
      {MENU_ITEM}
    </MenuItem>
  );
};

VpInfoMenuItem.propTypes = {
  item: PropTypes.object,
  onSelect: PropTypes.func,
  optionalLabelValue: PropTypes.string,
  disabled: PropTypes.bool,
  conditionalProps: PropTypes.object
};

export default VpInfoMenuItem;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoMenu/VpInfoMenuItem.jsx